module.exports = __webpack_public_path__ + "static/media/li2.bbb41bb0.jpg";